var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button success",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.addToCart.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-plus"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }